export const LAYOUT_CONTAINER_CLASS = 'mx-auto max-w-screen-desktop px-4';
export const LAYOUT_GRID_CLASS = 'grid grid-cols-[1fr_280px_min(100%,600px)_1fr]';
// eslint-disable-next-line max-len
export const SCROLLBAR_VISIBLE_CLASS = 'overflow-y-scroll [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-grey-300 dark:[&::-webkit-scrollbar-thumb]:bg-grey-700 [&::-webkit-scrollbar]:block [&::-webkit-scrollbar]:w-1.5';
